import React, { Children, cloneElement, isValidElement, useEffect, useState } from "react";
import { useLocation } from "react-router";

import ChevronDown from "../../../assets/svg/chevron-down.svg";
import ChevronUp from "../../../assets/svg/chevron-up.svg";
import Hamburger from "../../../assets/svg/hamburger.svg";
import { useClickOutside } from "../../hooks";

export default function SubMenuDropDown({ children, title, dropStyles = [], isBurger }) {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const modifiedChildren = Children.map(children, (child) => {
    if (!isValidElement(child)) {
      return child;
    }

    return cloneElement(child, {
      onClick: (event) => {
        if (child.props.onClick) {
          child.props.onClick(event);
        }

        setIsOpen(false);
      },
    });
  });

  const menuRef = useClickOutside(() => setIsOpen(false));

  const renderIcon = () => {
    if (isBurger) {
      return <Hamburger className="mobile-burger" />;
    }
    if (isOpen) {
      return <ChevronUp className="chevron" preserveAspectRatio="xMidYMid slice" />;
    }
    return <ChevronDown className="chevron" preserveAspectRatio="xMidYMid slice" />;
  };

  const handleClick = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <div className="sub-menu-container">
      <button
        type="button"
        aria-expanded={isOpen}
        ref={menuRef}
        className={`sub-menu-title ${isOpen ? "active" : ""}`}
        onClick={handleClick}
      >
        {title}
        <div className="submenu-icon">{renderIcon()}</div>
      </button>
      {isOpen && <div className={`sub-menu dark-cyan-fill ${dropStyles.join(" ")}`}>{modifiedChildren}</div>}
    </div>
  );
}
